/* src/app/views/auth/forbidden/forbidden.component.css */
/*# sourceMappingURL=forbidden.component.css.map */
